import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";

// Libraries
import { Form, InputGroup } from "react-bootstrap";


import moment from "moment/moment";


export default function ViewProduct() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [product, setProduct] = useState({
        name: "",
        code: "",
        supplierId: 0,
        costPrice: 0,
        salePrice: 0,
        haulageRate: 0,
        type: ""
    });
    const [orders, setOrders] = useState([]);
 
    useEffect(() => {
        

        // Load the product details
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/products/${params.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Product:", res.data);
                setProduct(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);

                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });
    }, [])

    useEffect(() => {
        console.log("product:", product)
        if (product.code != '') {

            // Load any recent orders for the product
            axios
                .get(`https://${process.env.REACT_APP_IP}/api/products/${product.supplierId}/${product.code}/orders`, {
                    headers: { Authorization: `bearer ${user.token}` },
                })
                .then((res) => {
                    console.log("Recent orders:", res.data);
                    setOrders(res.data);

                })
                .catch((err) => {
                    console.log(err);


                    if (err.response.status === 401) {
                        dispatch({ type: "LOGOUT" })
                        navigate("../")
                    }
                });
        }
    }, [product])

    

   

    return (
        <div className="page">

            <div className="row">
                <div className="col-12">
                    <h1>
                        {product && product.name}

                        {/* Edit Button */}
                        <Link to={`/Products/Edit/${product.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Edit</Link>

                    </h1>
                </div>
            </div>

           

            
            <div className="row">
                {/* Contact Details */}
                <div className="col-md-6">
                    <h3>Product Details</h3>

                   
                    <div className="row">
                        <div className="col-md-12">
                            { /* Code */}
                            <div className="row">
                                <div className="col-4">
                                    Code
                                </div>
                                <div className="col-8">
                                    {product.code}
                                </div>
                            </div>


                            { /* Product Name */}
                            <div className="row">
                                <div className="col-4">
                                    Name
                                </div>
                                <div className="col-8">
                                    {product.name}
                                </div>
                            </div>

                            { /* Product Type */}
                            <div className="row">
                                <div className="col-4">
                                    Product Type
                                </div>
                                <div className="col-8">
                                    {product.type}
                                </div>
                            </div>

                            { /* Supplier */}
                            <div className="row">
                                <div className="col-4">
                                    Supplier
                                </div>
                                <div className="col-8">
                                    {product.supplierName}
                                </div>
                            </div>

                            

                        </div>
                        
                    </div>

                   
                    

                    

                   

                    

                        
                    
                </div>

                {/* Pricing Details */}
                <div className="col-md-6">
                    <h3>Pricing Details</h3>

                    { /* Cost Price */}
                    <div className="row">
                        <div className="col-4">
                            Cost Price
                        </div>
                        <div className="col-8">
                            &pound;{product.costPrice.toFixed(2)}
                        </div>
                    </div>

                    { /* Sale Price */}
                    <div className="row">
                        <div className="col-4">
                            Sale Price
                        </div>
                        <div className="col-8">
                            &pound;{product.salePrice.toFixed(2)}
                        </div>
                    </div>

                    { /* Haulage Rate */}
                    <div className="row">
                        <div className="col-4">
                            Haulage Rate
                        </div>
                        <div className="col-8">
                            &pound;{product.haulageRate.toFixed(2)}
                        </div>
                    </div>
                </div>
            </div>
            
            

                <div className="row">
                    <div className="col-md-6">
                    <h3 style={{ marginTop: 20 }}>Recent Orders</h3>

                    {(orders && orders.length > 0) && (
                        <table width="100%" style={{ marginTop: 20 }}>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Order No</th>
                                    <th>Qty Ordered</th>
                                    <th>Cost Price</th>
                                    <th>Sale Price</th>
                                </tr>
                            </thead>
                            <tbody>

                                {orders.map((order) => ( 

                                    <tr key={order.id} style={{ cursor: "pointer" }}>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>{moment(order.orderDate).format("DD/MM/YYYY")}</td>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>{order.orderNumber}</td>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>{order.quantityOrdered}</td>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>&pound;{order.costPrice.toFixed(2)}</td>
                                        <td onClick={() => { navigate(`/Orders/View/${order.orderNumber}`) }}>&pound;{order.salePrice.toFixed(2)}</td>
                                    </tr>

                                ))}
                            </tbody>
                        </table>
                    )}
                    {(orders.length == 0) && (
                        <em>No orders found for this product</em>
                    )}
                    </div>
                </div>
            
           

            

        </div>
  )
}
